import { Box, VStack } from '@chakra-ui/react';
import React from 'react';
import { DanFullIcon } from '../icons/Icons';
import { Footer } from './Footer';
import { Header } from './Header';

export interface LayoutProps {
  children?: React.ReactNode;
  isLogin?: boolean;
  onLogoClick?: () => void;
}

export const Layout: React.FC<LayoutProps> = ({ children, isLogin, onLogoClick }) => (
  <VStack
    h={{ base: '100%' }}
    minH="100vh"
    overflowX="hidden"
    w="full"
    bg="blue.900"
    color="white"
    px={{ base: '24px', sm: '50px' }}
    py={{ base: '24px', sm: '40px' }}
    bgGradient="radial(85% 113.42% at -3.85% -15.58%, var(--chakra-colors-surfaceAccent) 33.2%, rgba(5, 9, 29, 0.00) 100%)"
  >
    {!isLogin && (
      <Box>
        <Header onClick={onLogoClick} />
      </Box>
    )}
    <Box
      mt={{ base: isLogin ? 0 : '32px', sm: isLogin ? 'auto' : '56px' }}
      mb={{ base: 0, sm: isLogin ? '56px' : '0' }}
      display={isLogin ? 'flex' : 'block'}
      flexDirection={isLogin ? 'column' : 'unset'}
      alignItems={isLogin ? 'center' : 'unset'}
    >
      {isLogin && (
        <DanFullIcon
          w={{ base: '90px', sm: '160px' }}
          h={{ base: '90px', sm: '160px' }}
          mb={{ base: 4, sm: 10 }}
        />
      )}

      {children}
    </Box>
    <Footer />
  </VStack>
);
